import React from "react";
import { IconButton } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import openInNewTab from "../../../utilities/newTab";

interface FileDownloadCGSProps {
    url: string
}

const FileDownloadCGS: React.FC<FileDownloadCGSProps> = ({ url }) => {
    if (!url) return null;
    
    return (
        <IconButton
            size="small"
            onClick={() => openInNewTab(url)}
            sx={{
                padding: '4px',
                width: '18px',
                height: '18px',
            }}
        >
            <FileDownloadOutlinedIcon sx={{ fontSize: '18px', color: '#1976d2' }} />
        </IconButton>
    );
};

export default FileDownloadCGS;
